import { render, staticRenderFns } from "./addParent.vue?vue&type=template&id=640a34c2&scoped=true&"
import script from "./addParent.vue?vue&type=script&lang=js&"
export * from "./addParent.vue?vue&type=script&lang=js&"
import style0 from "./addParent.vue?vue&type=style&index=0&id=640a34c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a34c2",
  null
  
)

export default component.exports